export const SEARCH_FEEDS_TITLE = 'Search Feeds'

export function isSearchFeedsCompany(company) {
  return company?.title === SEARCH_FEEDS_TITLE
}
